import { useEffect } from "react"
import { useLocation } from "react-router-dom"
import posthog from "posthog-js"

export default function PostHogPageViewTracker() {
    const location = useLocation()

    useEffect(() => {
        // Only track when the path actually changes
        if (import.meta.env.PROD && import.meta.env.VITE_POSTHOG_KEY) {
            posthog.capture("$pageview")
        }
    }, [location])

    return null
}
